// Third Party
import React from 'react';

// Components
import { SelectInput, SelectOption } from '@/views/components/inputs';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import ProposalPaperFormat from '@/types/proposal-paper-format';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';
import { PROPOSAL_PAPER_FORMAT } from '@/modules/proposal/utils/constants';

type Props = {
  onPaperFormatChange: (paperFormat: ProposalPaperFormat) => void;
  selectedFormat?: ProposalPaperFormat;
};

const ProposalPaperFormatSelector: React.FunctionComponent<Props> = ({ onPaperFormatChange, selectedFormat }: Props) => {
  const label = formatMessage('Proposal.Tabs.Options.PaperFormat.Label');

  return (
    <div className="proposal-option">
      <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
        <FormattedMessage id="Proposal.Tabs.Options.PaperFormat.Title" />
      </Typography>

      <SelectInput key={selectedFormat} selected={selectedFormat} onValueChange={onPaperFormatChange} compact aria-label={label}>
        {Object.values(PROPOSAL_PAPER_FORMAT).map(format => {
          const optionText = formatMessage(`Proposal.Tabs.Options.PaperFormat.${format}`);
          return (
            <SelectOption key={format} value={format}>
              {optionText}
            </SelectOption>
          );
        })}
      </SelectInput>
    </div>
  );
};

export default ProposalPaperFormatSelector;
